// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2faJ4","clinicsSelect":"styles_clinicsSelect__12n_4"};